
// import { LoadingAction, MsgModalAction } from '../action/AppAction';
// import { MsgModalConst } from '../constants/Constants';
import Messages from './Messages';
import _ from 'lodash';

// /**
//  * ローディングを表示
//  */
// export const showLoading = () => {
//   // LoadingAction.show();
// }

// /**
//  * ローディングを非表示に
//  */
// export const hideLoading = () => {
//   // LoadingAction.hide();
// }

// /**
//  * アラート種類
//  */
// export const MsgModalConst = {
//   Type: keymirror({
//     Info: null,
//     Warning: null,
//     Error: null
//   }),
//   Mode: keymirror({
//     Alert: null,
//     Confirm: null,
//   })
// };

// /**
//  * アラート表示
//  */
// export const Alert = {
//   info: (option) => {
//     option.type = MsgModalConst.Type.Info;
//     Alert._open(option);
//   },
//   warn: (option) => {
//     option.type = MsgModalConst.Type.Warning;
//     Alert._open(option);
//   },
//   error: (option) => {
//     option.type = MsgModalConst.Type.Error;
//     Alert._open(option);
//   },
//   _open: (option) => {
//     option.mode = MsgModalConst.Mode.Alert;
//     // MsgModalAction.open(option);
//   }
// }

// /**
//  * 確認ダイアログ表示
//  */
// export const Confirm = {
//   info: (option) => {
//     option.type = MsgModalConst.Type.Info;
//     Confirm._open(option);
//   },
//   warn: (option) => {
//     option.type = MsgModalConst.Type.Warning;
//     Confirm._open(option);
//   },
//   error: (option) => {
//     option.type = MsgModalConst.Type.Error;
//     Confirm._open(option);
//   },
//   _open: (option) => {
//     option.mode = MsgModalConst.Mode.Confirm;
//     // MsgModalAction.open(option);
//   }
// }

/**
 * 日本時間のISO形式文字列を返す
 * @param {Date} date
 */
export const toJstISOString = (date) => {
  if (!_.isDate(date)) { return ''; }
  const tzoffset = 1000 * 60 * 60 * 9;
  return (new Date(date.getTime() + tzoffset)).toISOString().slice(0, -1);
}

/**
 * フロント側メッセージ取得共通関数(K-A04)
 * @param {String} messageId
 * @param  {...any} args
 */
export const getConstMessage = (messageId, ...args) => {
  let msg = Messages[messageId];
  for (let i in args) {
    msg = msg.replace("{" + i + "}", String(args[i]))
  }
  return msg;
}

/**
 * 入力チェック共通関数
 * @param {Array} validationConfig
 * @param {Object} inputData
 */
export const validate = (inputData, validationConfig) => {
  let isValid = true;
  let errors = {};
  _.each(Object.keys(inputData), (key) => {
    const val = inputData[key];
    const validations = _.get(validationConfig, key)
    if (!validations) { return; }
    _.forEach(validations, (validator) => {
      const { res, msg } = validator(val);
      if (!res) {
        errors[key] = msg;
        isValid = false;
        return false;
      }
    });
  });

  return { isValid, errors };
}

/**
 * 参照権限によるフローティングメニューの活性、非活性制御
 * @param {Object} state
 */
// state.role(参照権限)が１ならfalse,２ならtrueを返す
export const isAllowedRole = (role) => role == 2;

/**
 * 郵便番号の正規表現チェック
 */
export const isPostalCode = (postalCode) => {
  return /^\d{3}-?\d{4}$/.test(postalCode);
}

//ランダム英数生成
export const createPassword = () => {
  const letters = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const string = letters + letters.toUpperCase() + numbers;

  const len = 8
  let password = ''

  for (let i = 0; i < len; i++) {
    password += string.charAt(Math.floor(Math.random() * string.length));
  }
  return password
}